import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { CompanyListsComponent } from './company-lists.component';
import { CompanyListsService }   from './company-lists.service';
import { CustomerSourceModel }   from './typings/customer-source';
import { PaymentMethodModel }    from './typings/payment-method';
import { ProductCategoryModel }  from './typings/product-category';
import { ProductGroupModel }     from './typings/product-group';
import { TemplateModel }         from '../templates/typings/template';

export const CompanyListsStates : Array<NgHybridStateDeclaration> = [
  {
    component: CompanyListsComponent,
    name     : 'app.company-lists',
    resolve  : [
      {
        deps     : [ CompanyListsService ],
        resolveFn: ( companyListsService : CompanyListsService ) : Promise<Array<CustomerSourceModel>> => companyListsService.getCustomerSources(),
        token    : 'customerSources'
      },
      {
        deps     : [ CompanyListsService ],
        resolveFn: ( companyListsService : CompanyListsService ) : Promise<Array<TemplateModel>> => companyListsService.getTemplates('document'),
        token    : 'documentTemplates'
      },
      {
        deps     : [ CompanyListsService ],
        resolveFn: ( companyListsService : CompanyListsService ) : Promise<Array<TemplateModel>> => companyListsService.getTemplates('email'),
        token    : 'emailTemplates'
      },
      {
        deps     : [ CompanyListsService ],
        resolveFn: ( companyListsService : CompanyListsService ) : Promise<Array<TemplateModel>> => companyListsService.getTemplates('invoice'),
        token    : 'invoiceNoteTemplates'
      },
      {
        deps     : [ CompanyListsService ],
        resolveFn: ( companyListsService : CompanyListsService ) : Promise<Array<TemplateModel>> => companyListsService.getTemplates('job_card'),
        token    : 'jobCardTemplates'
      },
      {
        deps     : [ CompanyListsService ],
        resolveFn: ( companyListsService : CompanyListsService ) : Promise<Array<PaymentMethodModel>> => companyListsService.getPaymentMethods(),
        token    : 'paymentMethods'
      },
      {
        deps     : [ CompanyListsService ],
        resolveFn: ( companyListsService : CompanyListsService ) : Promise<Array<ProductCategoryModel>> => companyListsService.getProductCategories(),
        token    : 'productCategories'
      },
      {
        deps     : [ CompanyListsService ],
        resolveFn: ( companyListsService : CompanyListsService ) : Promise<Array<ProductGroupModel>> => companyListsService.getProductGroups(),
        token    : 'productGroups'
      },
      {
        deps     : [ CompanyListsService ],
        resolveFn: ( companyListsService : CompanyListsService ) : Promise<Array<TemplateModel>> => companyListsService.getTemplates('sms'),
        token    : 'smsTemplates'
      },
      {
        deps     : [ CompanyListsService ],
        resolveFn: ( companyListsService : CompanyListsService ) : Promise<Array<TemplateModel>> => companyListsService.getTemplates('unit'),
        token    : 'unitForSaleTemplates'
      }
    ],
    url: '/company-lists'
  }
];
